import { useMutation } from '@tanstack/react-query';

import { addOnsRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';

export const useCancelAddOnSubscriptionMutation = () => {
  const mutation = useMutation({
    mutationFn: addOnsRepo.cancelAddOnSubscription,
  });

  return useMutationMemoized(mutation);
};

export type CancelAddOnSubscriptionMutation = ReturnType<typeof useCancelAddOnSubscriptionMutation>;
